import React from 'react';
import styled from 'styled-components';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import {LabelForm, LabelCabecera, LabelNota } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { cargarCatalogos, cargarCatalogoEstados } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cargar_Devolucion } from '../../actions/ventas/act_ven04';
import { cargar_Factura, inicializarFactura } from '../../actions/ventas/act_ven02';
import global_axios from '../../funciones_globales/interaccionapi';
import { formatearNumeroEntero, formatearNumeroDecimal, formatearFechaMoment_a_String, completar_String } from '../../funciones_globales/format';
import { validarCampoString, validarPermisoAcceso, validarFechaMomentEnFormatoString, validarFechaTransaccionSeleccionada } from '../../funciones_globales/utils';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText} from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import NumeroComprobante from '../componentes_generales/numeroComprobante/numeroComprobante';
import { seleccionar_PuntoFacturacion } from '../../actions/ventas/act_ven02';
import { seleccionar_NumeroComprobante } from '../../actions/generales/act_gen04';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { cargar_DevolucionElectronica } from '../../actions/ventas/act_ven05';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { obtenerSecuencial } from '../../funciones_globales/parametros';

const LabelTotales = styled.label`
  display: inline-block;
  font-size: 10px;
  color: green;
`;

const LabelValorTotales = styled.label`
  display: inline-block;
  font-size: 9px;
  font-weight: bold;
  align-text: right;
`;

class FormVen04 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {     
      porcentajeDsctoPlazo:0,//CAMBIOS DSCTO PLAZO 20200614
      totalDsctoPlazo:0,//CAMBIOS DSCTO PLAZO 20200614            
      devolucionId: '',
      detDevolucion: [],
      tiposDevolucion: [],
      formasPago: [],
      tipoDevolucion_sel: null,
      cliente_Sel: null,
      vendedor_Sel: null,
      formaPago_sel: null,
      operacion: 'G', //Operacion: G-> Nuevo; M-> Modificar(Sólo Anular)      
      idFacturaSel: '',
      ptoEmiFacturaSel: '',
      secFacturaSel: '',
      subtotalConIva: parseFloat(0),
      subtotalSinIva: parseFloat(0),
      totalDscto: parseFloat(0),
      totalDsctoLinea: parseFloat(0),
      porcentajeIva: parseFloat(0),
      valorIva: parseFloat(0),
      total: parseFloat(0),
      porcentajeDscto: parseFloat(0),
      observacion: '',
      devElectronica: '',
      fechaDevolucion: null,
      estadosDevolucion: [],
      porGarantia: false,
      estadoActual: 'P',
      secuencialDevolucion: null,
      columnsDefGridDetDevolucion: [         
        { header: "No.",
          field: "Secuencia",
          width: 40,
          type: "string"
        },
        {
          header: "Cód. Art.",
          field: "Articulo",
          width: 90,
          type: "string"
        },
        { header: "Descripción",
          field: "Descripcion",
          width: 355,
          type: "string"
        },
        { header: "Promoción",
          field: "PromoFact",
          width: 80,
          type: "string"
        },
        { header: "Cantidad",
          field: "CantFact",
          width: 80,
          type: "num_entero"
        },       
        { header: "P. Unit.",
          field: "PrecioUnit",
          width: 80,
          type: "num_decimal"
        },
        { header: "Dscto.",
          field: "DsctoFact",
          width: 80,
          type: "num_entero"
        },
        { header: "Subtotal",
          field: "Subtotal",
          width: 90,
          type: "num_decimal"
        },
        { header: "Devuelto",
          field: "DevolucionAcum",
          width: 80,
          type: "num_entero"
        },
        { header: "A Devolver",
          field: "Devolucion",
          width: 80,
          type: "num_entero_edit",
          editable: true
        },
      ]      
    };

    this.gridDetDevolucionOptions = {
      enableColResize: true,
      enableSorting: true,

      onRowDataChanged: (()=>{
        this.calculoTotales();
      }),

      onCellEditingStarted: ((event)=> {        
          if(event.data.PromoFact==='*'){
            this.apiGridDetDevolucion.stopEditing(true);
            alert('No se puede devolver artículos que hayan sido dados en promoción.');
            return;
          }
          if(event.data.PromoFact==='X'){
            this.apiGridDetDevolucion.stopEditing(true);
            alert('No se puede devolver artículos que hayan sido utilizados para generar promoción.');
            return;
          }
      }),

      onCellValueChanged: ((event)=>{ 
        let valorAnt = event.oldValue;
        let valorNuevo = event.newValue;

        if (event.colDef.field === 'Devolucion'){            

          // Validación del valor ingresado:
          if(formatearNumeroEntero(valorNuevo)===0){
            alert('La cantidad que ingresó para devolver es incorrecta.');
            event.data.Devolucion = valorAnt;
            this.apiGridDetDevolucion.refreshCells();
            return;
          }

          // Validación de devolución acumulada no puede ser mayor a cantidad de la factura:
          let devAcum = (event.data.DevolucionAcum===null || event.data.DevolucionAcum === undefined)?0:event.data.DevolucionAcum;
          let cantFactura = event.data.CantFact;
          if (formatearNumeroEntero(cantFactura) < (formatearNumeroEntero(valorNuevo) + formatearNumeroEntero(devAcum))){
            alert('La devolución no puede ser mayor que la cantidad facturada.');
            event.data.Devolucion = valorAnt;
            this.apiGridDetDevolucion.refreshCells();
            return;
          }

          this.calculoTotales();
        }
      })
    };
    
    this.onGridDetDevolucionReady = this.onGridDetDevolucionReady.bind(this);
    this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
    this.getDevolucionById = this.getDevolucionById.bind(this);    
    this.cargarFactura = this.cargarFactura.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.guardarDevolucion = this.guardarDevolucion.bind(this);
    this.aplicarDevolucionTotal= this.aplicarDevolucionTotal.bind(this);
    this.calculoTotales = this.calculoTotales.bind(this);
    this.anularDevolucion = this.anularDevolucion.bind(this);
    this.imprimirDevolucion = this.imprimirDevolucion.bind(this);
  }
  
  cambiarValoresInput(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  cargarFactura(){    
    if (!validarCampoString(this.props.numeroComprobante, 17)){
      alert('No ha especificado el No. de Factura correctamente.');
      return;
    }

    let establec = this.props.numeroComprobante.slice(0,3);
    let ptoEmision = this.props.numeroComprobante.slice(4,7);
    let secuencial = this.props.numeroComprobante.slice(8);
    
    this.props.cargar_Factura(establec, ptoEmision, secuencial)
    .then(()=>{
      let factura = this.props.facturaSel;
    
      if ( factura===null){
        alert('La factura: ' + this.props.numComprobSel + ' no existe.');
        return;
      }else{
        if (factura.Status==='A'){
          alert('La factura que ha seleccionado está anulada.');
          return;
        }

        /* Si se trata de factura de devolución por garantía */
        if (validarCampoString(factura.ParaDevolucion,6)){
          this.props.cargar_DevolucionElectronica(factura.ParaDevolucion)
          .then(()=>{
            let devElectronica = this.props.devolucionElectSel;
            
            if(devElectronica){
              if (devElectronica.Status === "N"){
                alert("La devolución de esta factura ya fue aplicada.");
                return;
              }
              if (devElectronica.Status === "O"){
                alert("Está pendiente aplicar los artículos que no son por garantía en la devolución electrónica: " + devElectronica.Devolucion);
                return;
              }

              if (devElectronica.Status !== "GT"){
                alert("La devolución electrónica relacionada a esta factura aún no está lista.");
                return;
              }

              this.setState({porGarantia: true, devElectronica: devElectronica.Devolucion});

            }else{
              alert('Se produjo un error al cargar la información de la devolución electrónica asociada a la factura especificada.');
              return;
            }
          });
        }

        let articulosConDevolucionTmp = "";
        let detDevolucion = [];
        //Se procede a cargar la bodega a devolver acorde al parametro : 'D' WILLY 2020-01-29
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
          url: '/devoluciones/obtener/bodegaParametrizada',
          method: 'GET'
        })
        .then((response)=>{
          this.props.cambiar_VisualizacionLoading(false);
         
          let bodegaParametrizada= response.data.Codigo
          factura.detFactura.forEach(itemFactura => {

            let porcDescuentoPlazo= itemFactura.art.Codigo.trim()==='EMBA'?0:factura.PorcentajeDsctoPlazo;////DSCTO PLAZO 20200623 WILLY    
            let PreUnitDesPlazo=parseFloat(multiplicarDecimales(itemFactura.Precio, parseFloat(porcDescuentoPlazo)/100));//Rtoala 2020-02-18
            let PreUnitDesPlazoDescontado= parseFloat(parseFloat(itemFactura.Precio)-parseFloat(PreUnitDesPlazo));//DSCTO PLAZO 20200623 WILLY
           

            let precioConDscto = parseFloat(PreUnitDesPlazoDescontado) - parseFloat(multiplicarDecimales(PreUnitDesPlazoDescontado, parseFloat(itemFactura.Descuento)/100));
								   
								   
									 
	 

										   
            let subtotalConDscto = parseFloat(multiplicarDecimales(itemFactura.Cantidad, precioConDscto)).toFixed(2);
           
          
            /* Se concatenan los articulos que tienen un valor en DevueltoTmp(DETmp) en DFactura */
            articulosConDevolucionTmp += parseFloat((Number.isNaN(itemFactura.DevueltoTmp)?0:itemFactura.DevueltoTmp))>0?itemFactura.art.Codigo:"";
            console.log("EN LA DEVOLUCIÓN...............")
            console.log(itemFactura)
            detDevolucion.push(
            { Secuencia: itemFactura.Secuencia,
              Articulo: itemFactura.art.Codigo,
              Descripcion: itemFactura.art.Nombre,
              CantFact: itemFactura.Cantidad,
              PromoFact: itemFactura.UsadoEnPromocion===true?'X':(itemFactura.EsPromocion===true?'*':''),
              PrecioUnit: itemFactura.Precio,
              CostoPromedio: itemFactura.CostoPromedio,//WILLY 2020-02-20 COSTO PROMEDIO  itemFactura.CostoPromedio
              Bodega:bodegaParametrizada,
              PorcDescuento: itemFactura.Descuento,
              DsctoFact: itemFactura.Descuento,
              Subtotal: subtotalConDscto,
              DevolucionAcum: formatearNumeroEntero(itemFactura.Devuelve) + formatearNumeroEntero((itemFactura.DevueltoTmp===null?0:itemFactura.DevueltoTmp)),
              Devolucion: null,
              GravaIva: itemFactura.Iva,
              Sublinea: itemFactura.art.Sublinea
            });
          });
  
          if (articulosConDevolucionTmp.toString().length>0){
            alert(`Los articulos: ${articulosConDevolucionTmp} tienen una devolución electrónica pendiente.`);
          }
  
          this.setState({ detDevolucion, cliente_Sel: factura.cli, vendedor_Sel: factura.vend, porcentajeIva: parseFloat(factura.PorcentajeIva),
                          idFacturaSel: factura.Factura, ptoEmiFacturaSel: factura.pemision, secFacturaSel: factura.Factura_Generada,
                          formaPago_sel: factura.FormaPago, porcentajeDscto: parseFloat(factura.Descuento===null?0:factura.Descuento),porcentajeDsctoPlazo:factura.PorcentajeDsctoPlazo
                                  });//WILLY DSCTO PLAZO 2020-06-22
        })
        .catch((error)=>{
          this.props.cambiar_VisualizacionLoading(false);
          alert(error.response?error.response.data.msg:error.message);
        });
        
      }
    });
  }

  onGridDetDevolucionReady(params) {
    this.apiGridDetDevolucion = params.api;
    this.columnApiGridDetDevolucion = params.columnApi;
  }
  
  componentDidMount(){
    Promise.all([      
      cargarCatalogos('TIPODEVO'),
      cargarCatalogos('FORMAPAGO'),
      cargarCatalogoEstados('Devolucion', 'Status'),
      obtenerSecuencial('Devolucion'),
      this.props.generar_LogAuditoriaIngresoForm('0404')
    ])
    .then(([tiposDevol, formasPago, estadosDevolucion, secuencialDevolucion]) => {
      let fechaProceso = getFechaProcesoPorModulo('04');
      this.setState(
        { tiposDevolucion: tiposDevol,
          formasPago,
          estadosDevolucion,
          fechaDevolucion: moment(fechaProceso, 'DD/MM/YYYY'),
          secuencialDevolucion: completar_String((secuencialDevolucion.codigo - 1).toString(), '0', 6)
        });
    })
    .catch(error => {
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0404');
  }

  inicializarPuntoFacturacionDeNumeroComprobante(){
    let puntoFacturacionDefault;

    for(let i=0; i<this.props.puntosFacturacion.length; i++){
      if (this.props.puntosFacturacion[i].EsDefault==='S'){
          puntoFacturacionDefault = this.props.puntosFacturacion[i];
          break;
      }
    }  
    let numeroComprobante = puntoFacturacionDefault.Establecimiento + '-' + puntoFacturacionDefault.PtoEmision;
    this.props.seleccionar_NumeroComprobante(numeroComprobante);    
  }
  
  limpiar(){
    Promise.all([      
      obtenerSecuencial('Devolucion')
    ])
    .then(([secuencialDevolucion]) => {
      let fechaProceso = getFechaProcesoPorModulo('04');
      this.setState({
        devolucionId: '',
        operacion: 'G',
        detDevolucion: [],
        cliente_Sel: null, 
        vendedor_Sel: null,      
        tipoDevolucion_sel: null,      
        idFacturaSel: '',
        ptoEmiFacturaSel: '',
        secFacturaSel: '',
        subtotalConIva: parseFloat(0),
        subtotalSinIva: parseFloat(0),
        totalDscto: parseFloat(0),
        totalDsctoLinea: parseFloat(0),
        porcentajeIva: parseFloat(0),
        valorIva: parseFloat(0),
        porcentajeDscto: parseFloat(0),
        total: parseFloat(0),
        observacion: '',
        formaPago_sel: null,
        devElectronica: '',
        fechaDevolucion: moment(fechaProceso, 'DD/MM/YYYY'),
        estadoActual: 'P',
        porGarantia: false,
        secuencialDevolucion: completar_String((secuencialDevolucion.codigo - 1).toString(), '0', 6)
      });
      this.props.inicializarFactura();
      this.inicializarPuntoFacturacionDeNumeroComprobante();
    })
    .catch((error)=>{
      alert('Se produjo un error al consultar el código de la última Devolución generada.: ' + error);
    });
  }

  getDevolucionById(){
    if (!validarCampoString(this.state.devolucionId, 6)){
      alert('No ha especificado el No. de Devolución correctamente.');      
      return;
    }else{
      this.props.cargar_Devolucion(this.state.devolucionId)
      .then(()=>{
        try{

          let devolucion = this.props.devolucionSel;
          
          if ( devolucion===null){
            alert('La Devolución No.: ' + this.state.devolucionId + ' no existe.');
            return;
          }else{
            
            let detDevolucion = [];
            devolucion.detDevolucion.forEach(itemDev => {
              let precioConDscto = parseFloat(itemDev.PrecioUnit) - parseFloat(multiplicarDecimales(itemDev.PrecioUnit, parseFloat(itemDev.DsctoFact)/100));
              let subtotalConDscto = parseFloat(multiplicarDecimales(itemDev.CantFact, precioConDscto)).toFixed(2);
    
              detDevolucion.push(
                { Secuencia: itemDev.Secuencia,
                  Articulo: itemDev.Articulo,
                  Descripcion: itemDev.Descripcion,
                  CantFact: itemDev.CantFact,
                  PromoFact: itemDev.PromoFact,
                  PrecioUnit: itemDev.PrecioUnit,
                  CostoPromedio: itemDev.CostoPromedio,
                  Bodega: itemDev.Bodega,                  
                  DsctoFact: itemDev.DsctoFact,
                  Subtotal: subtotalConDscto,
                  DevolucionAcum: itemDev.DevolucionAcum,
                  Devolucion: itemDev.CantDevolucion,
                  GravaIva: itemDev.GravaIva,
                  Sublinea: itemDev.Sublinea
                });
            });
            
    
            this.setState({ operacion: 'M', detDevolucion, cliente_Sel: devolucion.cli, vendedor_Sel: devolucion.vend, porcentajeIva: parseFloat(devolucion.PorcentajeIva),
                            idFacturaSel: devolucion.fact.Factura, ptoEmiFacturaSel: devolucion.fact.pemision, secFacturaSel: devolucion.fact.Factura_Generada,
                            tipoDevolucion_sel: devolucion.Tipo, observacion: devolucion.Observacion, formaPago_sel: devolucion.FormaPago,
                            devElectronica: devolucion.ForDev, fechaDevolucion: moment(devolucion.Fecha, 'DD/MM/YYYY'), estadoActual: devolucion.Status,
                            porcentajeDscto: parseFloat(devolucion.fact.Descuento===null?0:devolucion.fact.Descuento),porcentajeDsctoPlazo:devolucion.PorcentajeDsctoPlazo,totalDsctoPlazo:devolucion.TotalDsctoPlazo //DSCTO PLAZO 2020- 06-23
            });
            
            this.props.seleccionar_PuntoFacturacion(devolucion.PtoFacturacion);
            let numeroFactura = devolucion.fact.Establecimiento + '-' + devolucion.fact.pemision + '-' + devolucion.fact.Factura_Generada;
            this.props.seleccionar_NumeroComprobante(numeroFactura);
          }
        }catch(error){
          alert('Ha ocurrido un error: ' + error);
        }
      });     
    }    
  }

  guardarDevolucion(){
    
    if (this.state.operacion==='M'){
      alert("No está permitido realizar modificaciones a la devolución, sólo puede anular.");
      return;
    }
  
    let nroItemsDevueltos = this.verificarItemsConDevolucion();
    let totalItems = this.state.detDevolucion.length;
    
    if (nroItemsDevueltos===0){
      alert('No ha especificado ningún artículo para devolver.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let fechaDevolucion = formatearFechaMoment_a_String(this.state.fechaDevolucion);
    if (!validarFechaMomentEnFormatoString(fechaDevolucion)){
      alert('La fecha de Devolución es inválida.');
      return;
    }
    let fechaProceso = getFechaProcesoPorModulo('04');
    if (this.props.permiteCambioFProceso==='S'){
      let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaDevolucion, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }

    if (!validarCampoString(this.state.tipoDevolucion_sel, 2)){
      alert('No ha especificado el tipo de devolución.');
      return;
    }

    if ((this.state.tipoDevolucion_sel==='01' || this.state.tipoDevolucion_sel==='03' || this.state.tipoDevolucion_sel==='16') 
        && (formatearNumeroEntero(nroItemsDevueltos)<formatearNumeroEntero(totalItems))){
      alert('Para los tipos de devolución: 01, 03 y 16 debe realizar la devolución de todos los artículos.');
      return;
    }

    if (this.props.puntoFacturacionSel===null){
      alert('No ha especificado un punto de facturación.');
      return;
    }

    let itemsDevueltos = [];
    this.state.detDevolucion.forEach(item => {
      if (item.Devolucion!==null && item.Devolucion!==undefined && item.Devolucion!==''){
        if (!isNaN(item.Devolucion) && formatearNumeroEntero(item.Devolucion)>0){
          itemsDevueltos.push({
            SecuenciaFact: item.Secuencia,
            Articulo: item.Articulo,
            Bodega: item.Bodega,
            CantidadFact: item.CantFact,
            CantDevolucion: item.Devolucion,
            Precio: item.PrecioUnit,
            CostoPromedio: item.CostoPromedio,
            CantPromocionFact: item.PromoFact,
            PorcDescuento: item.DsctoFact,
            GravaIva: item.GravaIva
          });
        }
      }
    });
    
    let dataDevolucion = {
      Cliente: this.state.cliente_Sel.Codigo,
      Factura: this.state.secFacturaSel,
      FormaPago: this.state.formaPago_sel,
      Vendedor: this.state.vendedor_Sel.Codigo,
      Fecha: fechaProceso,
      Observacion: this.state.observacion,
      Descuento: parseFloat(this.state.totalDscto).toFixed(2),
      DescuentoLinea: parseFloat(this.state.totalDsctoLinea).toFixed(2),
      PorcentajeIva: parseFloat(this.state.porcentajeIva),
      Iva: parseFloat(this.state.valorIva).toFixed(2),
      TotalConIva: parseFloat(this.state.subtotalConIva).toFixed(2),
      TotalSinIva: parseFloat(this.state.subtotalSinIva).toFixed(2),
      Valor: parseFloat(this.state.total).toFixed(2),
      Moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
      Dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
      Usuario: getItemDatosSesion('usuario'),
      Tipo: this.state.tipoDevolucion_sel,
      PtoEmiFact: this.state.ptoEmiFacturaSel,
      FacturaGen: this.state.idFacturaSel,
      PtoFacturacion: this.props.puntoFacturacionSel,
      DevElectronica: this.state.devElectronica,
      IdRegAudit: this.props.idRegAudit,
      detalleDevolucion: itemsDevueltos,
      porcentajeDsctoPlazo: this.state.porcentajeDsctoPlazo,
      totalDsctoPlazo:this.state.totalDsctoPlazo
			
    };
    
    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      url: '/devoluciones',
      method: 'POST',
      data: dataDevolucion
    })
    .then((response)=>{
      alert('Transacción procesada con éxito. Devolución: ' + response.data.codigoDevolucion);
      this.props.cambiar_VisualizacionLoading(false);
      this.limpiar();
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  anularDevolucion(){
    let operacion = this.state.operacion;
    let devolucionId = this.state.devolucionId;

    if (operacion==='G'){
      alert('No ha seleccionado la Devolución que desea anular.');
      return;
    }

    if (operacion==='M'){
      if (!validarCampoString(devolucionId, 6)){
        alert('No ha especificado correctamente la Devolución que desea anular.');
        return;
      }
    }

    if (this.state.estadoActual==='A'){
      alert('La Devolución seleccionada ya se encuentra anulada.');
      return;
    }    

    let anular = window.confirm(`¿Está seguro de anular la Devolución: ${devolucionId}?`);
    if (!anular){
       return;
    }

    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      url: '/devoluciones/' + devolucionId,
      method: 'DELETE',
      headers: {'idregaudit': this.props.idRegAudit}
    })
    .then(()=>{
      alert('Se anuló correctamente la Devolución No: (' + devolucionId + ')');
      this.props.cambiar_VisualizacionLoading(false);
      this.limpiar();
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  aplicarDevolucionTotal(){
    let detDevolucion = [];

    this.state.detDevolucion.forEach((itemDev)=>{
      if((itemDev.PromoFact !== '*' && itemDev.PromoFact !== 'X')){
        let articulosDevueltos = (itemDev.DevolucionAcum===null)?0:itemDev.DevolucionAcum;
        let articulosADevolver = (formatearNumeroEntero(itemDev.CantFact) - formatearNumeroEntero(articulosDevueltos))<0?0:formatearNumeroEntero(itemDev.CantFact) - formatearNumeroEntero(articulosDevueltos);
        detDevolucion.push({
          ...itemDev,
          Devolucion: formatearNumeroEntero(articulosADevolver)
        });
      }
    });

    this.setState({detDevolucion});
    this.calculoTotales();
  }

  calculoTotales(){    
    
    let porcentajeIva = parseFloat(this.state.porcentajeIva/100).toFixed(2);
    let porcentajeDscto = parseFloat(this.state.porcentajeDscto/100).toFixed(2);
    let subtotalConIva = parseFloat(0);
    let subtotalSinIva = parseFloat(0);    
    let totalDscto = parseFloat(0);
    let totalDsctoLinea = parseFloat(0);
    let valorIva = parseFloat(0);
    let total = parseFloat(0);
    let valorFlete = parseFloat(0);
    let totalDsctoPlazo=parseFloat(0);
    let precioConDsctoPlazo=parseFloat(0);
    let dsctoPlazoEnPrecio=parseFloat(0);
    

    this.state.detDevolucion.forEach(item => {
      if (item.Devolucion !== null && item.Devolucion !== undefined && item.Devolucion!==''){         

        if (!isNaN(item.Devolucion) && formatearNumeroEntero(item.Devolucion)>0){
          let porcDescuentoPlazo= item.Articulo.trim()==='EMBA'?0:this.state.porcentajeDsctoPlazo;////DSCTO PLAZO 20200623 WILLY
          dsctoPlazoEnPrecio = parseFloat(multiplicarDecimales(item.PrecioUnit, parseFloat(porcDescuentoPlazo)/100));
          precioConDsctoPlazo = parseFloat(item.PrecioUnit) - parseFloat(dsctoPlazoEnPrecio);
		      let dsctoEnPrecio = parseFloat(multiplicarDecimales(precioConDsctoPlazo, parseFloat(item.DsctoFact)/100));//WILLY 2020-02-18
		      let valorDsctoPlazo = multiplicarDecimales(item.Devolucion, dsctoPlazoEnPrecio).toFixed(2);
          totalDsctoPlazo = parseFloat(parseFloat(totalDsctoPlazo) + parseFloat(valorDsctoPlazo)).toFixed(2);
					
          let precioConDscto = parseFloat(precioConDsctoPlazo) - parseFloat(dsctoEnPrecio);          
          let subtotalConDscto = multiplicarDecimales(item.Devolucion, precioConDscto).toFixed(2);
          let valorDscto = multiplicarDecimales(item.Devolucion, dsctoEnPrecio).toFixed(2);

          if (item.GravaIva){
            subtotalConIva = parseFloat(subtotalConIva) + parseFloat(subtotalConDscto);
          }else{
            subtotalSinIva = parseFloat(subtotalSinIva) + parseFloat(subtotalConDscto);
          }
          totalDsctoLinea = parseFloat(totalDsctoLinea) + parseFloat(valorDscto);
          valorFlete += parseFloat(item.Sublinea==='SX'?subtotalConDscto:0);
        }
      }
    });
    
    totalDscto = multiplicarDecimales(parseFloat(subtotalConIva) + parseFloat(subtotalSinIva) - parseFloat(valorFlete), porcentajeDscto).toFixed(2);
    
    if (parseFloat(subtotalConIva)>parseFloat(totalDscto)){
      subtotalConIva = parseFloat(subtotalConIva) - parseFloat(totalDscto);
    }else{
      subtotalSinIva = parseFloat(subtotalSinIva) - parseFloat(totalDscto);
    }

    totalDscto = parseFloat(totalDscto) + parseFloat(totalDsctoLinea)
    valorIva = multiplicarDecimales(subtotalConIva, porcentajeIva).toFixed(2);
    total = parseFloat(subtotalConIva) + parseFloat(valorIva) + parseFloat(subtotalSinIva);
    this.setState({
      subtotalConIva: parseFloat(subtotalConIva),
      subtotalSinIva: parseFloat(subtotalSinIva),
      totalDsctoLinea: parseFloat(totalDsctoLinea),
      totalDscto: parseFloat(totalDscto),
      valorIva: parseFloat(valorIva),
      total: parseFloat(total),
      totalDsctoPlazo:parseFloat(totalDsctoPlazo)
    });
  }

  verificarItemsConDevolucion(){
    let contItemsConDevolucion = 0;
    this.state.detDevolucion.forEach(item => {
      if (item.Devolucion !== null && item.Devolucion !== undefined){
        if (!isNaN(item.Devolucion) && formatearNumeroEntero(item.Devolucion)>0){
          contItemsConDevolucion+=1;
        }
      }
    });
    return contItemsConDevolucion;
  }

  imprimirDevolucion(){
    let operacion = this.state.operacion;
    let devolucionId = this.state.devolucionId;

    if (operacion==='G'){
      alert('No ha seleccionado la Devolución que desea imprimir.');
      return;
    }

    if (operacion==='M'){
      if (!validarCampoString(this.state.devolucionId, 6)){
        alert('No ha especificado correctamente la Devolución que desea imprimir.');
        return;
      }
    }

    visualizarReporteEnPdf('&rpt=4&param1=' + devolucionId);
  }

  render(){
    return(
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Devolución</TituloForm>
          <LabelCabecera>Últ. Devolución: {this.state.secuencialDevolucion===null?'':this.state.secuencialDevolucion}</LabelCabecera>
        </HeaderForm>
        <CuerpoForm>
            <Row>
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Devolución:</LabelForm>
                    <InputSearch tipoInput='text' nombre='devolucionId' maxLength={7} placeholder='Devolución' valor={this.state.devolucionId} func_CambiarValor={this.cambiarValoresInput} 
                      func_BuscarValor={this.getDevolucionById} func_OnFocus={()=>{this.limpiar()}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                    <LabelForm>Factura:</LabelForm>
                    <NumeroComprobante funcBuscarComprobante={this.cargarFactura}/>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                    <LabelForm>Tipo:</LabelForm>
                    <ReactSelect options={ this.state.tiposDevolucion } value={this.state.tipoDevolucion_sel} func_onChange={(value)=>{this.setState({tipoDevolucion_sel: (value===null || value===undefined)?null:value.value })}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Fecha:</LabelForm>
                    <PickerFecha fechaSeleccionada={this.state.fechaDevolucion} disabled={!(this.props.permiteCambioFProceso==='S')}
                      func_onChange={(fecha)=>{this.setState({fechaDevolucion: fecha})}}/>
                </ContainerCol>                
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Pto. Facturación:</LabelForm>
                    <PuntoFacturacion/>
                </ContainerCol>
            </Row>
            <Row>                
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Cliente:</LabelForm>
                  <InputText name="cliente" disabled={true} value={this.state.cliente_Sel===null?'':(this.state.cliente_Sel.Codigo + ' - ' + this.state.cliente_Sel.Nombre)}/>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Vendedor:</LabelForm>
                  <InputText name="vendedor" disabled={true} value={this.state.vendedor_Sel===null?'':(this.state.vendedor_Sel.Codigo + ' - ' + this.state.vendedor_Sel.Nombre)}/>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>D. Electrónica.:</LabelForm>
                  <InputText name="devElectronica" placeholder='D. Elect.' value={this.state.devElectronica}
                    onChange={this.cambiarValoresInput}/>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Forma Pago:</LabelForm>
                  <ReactSelect options={ this.state.formasPago } disabled={true} value={this.state.formaPago_sel} func_onChange={(value)=>{this.setState({formaPago_sel: value!==null?value.value:null})}}/>
                </ContainerCol>                
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Estado:</LabelForm>
                  <ReactSelect options={ this.state.estadosDevolucion } disabled={true} value={this.state.estadoActual}/>
                </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-12'>
                <LabelForm>Observación:</LabelForm>
                <InputText name='observacion' placeholder='Observación' value={this.state.observacion} onChange={this.cambiarValoresInput}/>
              </ContainerCol>
            </Row>
            <Row>
                <ContainerCol className='col-sm-12'>
                <AgGridRender altura='300px' data={this.state.detDevolucion} columnas={this.state.columnsDefGridDetDevolucion}
                gridOptions={this.gridDetDevolucionOptions} onGridReady={this.onGridDetDevolucionReady}/>
                </ContainerCol>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <LabelNota>{`Promoción.- *: Artículo dado en promoción. X: Artículo usado para calcular promoción.`}</LabelNota>
              </div>
            </Row>
            <Row>           
              <div className='col-sm-2'>
                <LabelTotales>Base Iva: </LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelTotales>Base Sin Iva: </LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelTotales>Descuento: </LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelTotales>{`Dscto. Por Plazo(${this.state.porcentajeDsctoPlazo}%):`}</LabelTotales>
              </div>  
              <div className='col-sm-1'>
                <LabelTotales>% Iva: </LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelTotales>Valor Iva: </LabelTotales>
              </div>
              <div className='col-sm-1'>
                <LabelTotales>Total: </LabelTotales>
              </div>
            </Row>
            <Row>           
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalConIva)}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalSinIva)}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDscto)}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
               <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDsctoPlazo)}</LabelValorTotales>  
              </div>  
              <div className='col-sm-1'>
                <LabelValorTotales>{this.state.porcentajeIva}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.valorIva)}</LabelValorTotales>
              </div>
              <div className='col-sm-1'>
               <LabelValorTotales>{formatearNumeroDecimal(this.state.total)}</LabelValorTotales>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <div className='btn-group pull-right'>
                    <button type='button' className='btn btn-success btn-sm' disabled={this.state.operacion==='M'?true:false} onClick={this.aplicarDevolucionTotal}><i className='fa fa-cog fa-lg'/> Aplicar Dev. Total</button>
                    <button type='button' className='btn btn-primary btn-sm' disabled={this.state.operacion==='M'?true:false} onClick={this.guardarDevolucion}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                    <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirDevolucion}><i className='fa fa-print fa-lg'/> Imprimir</button>
                    <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                    <button type='button' className='btn btn-danger btn-sm' onClick={this.anularDevolucion}><i className='fa fa-window-close  fa-lg'/> Anular</button>
                </div>
              </div>
            </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }  
}

const mapStateToProps = state =>{
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            puntoFacturacionSel: state.ventas.ptoFacturacionSel,
            facturaSel: state.ventas.facturaSel,
            devolucionSel: state.ventas.devolucionSel,
            devolucionElectSel: state.ventas.devolucionElectronSel,
            numeroComprobante: state.generales.numComprobSel,
            puntosFacturacion: state.ventas.puntosFact,
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cargar_Factura, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                              cargar_Devolucion, seleccionar_PuntoFacturacion, seleccionar_NumeroComprobante,
                              cambiar_VisualizacionLoading, cargar_DevolucionElectronica, inicializarFactura }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen04);